import { IPlacement, TenantVertical } from "@sp-crm/core";
import type { AppRouter } from "@sp-crm/server/rpc";
import type { inferProcedureOutput } from "@trpc/server";

export type ClientTransferRequestSummary = inferProcedureOutput<
    AppRouter["clientTransfer"]["pendingOutgoing"]
>[number];

export type ClientTransferSubject = ClientTransferRequestSummary["subject"];

export const verticalForSubject = (subject: ClientTransferSubject): TenantVertical => {
    switch (subject.kind) {
        case "placement":
            return "placement";
        case "homeCareLead":
            return "homeCare";
    }
};

export interface TransferSearchLocation {
    address: string;
    city: string;
    state: string;
    zip: string;
}

interface TransferSearchLocationParts {
    address1: string | null;
    city: string | null;
    state: string | null;
    zip: string | null;
}

export const placementTransferLocation = (
    placement: IPlacement,
): TransferSearchLocation | null => {
    if (!placement.geocodeableRepresentation()) {
        return null;
    }

    return {
        address: placement.bestLocationAddress ?? "",
        city: placement.bestLocationCity ?? "",
        state: placement.bestLocationState?.toUpperCase() ?? "",
        zip: placement.bestLocationZip ?? "",
    };
};

export const contactTransferLocation = (
    contact: TransferSearchLocationParts,
): TransferSearchLocation | null => {
    const location = {
        address: contact.address1 ?? "",
        city: contact.city ?? "",
        state: contact.state?.toUpperCase() ?? "",
        zip: contact.zip ?? "",
    };

    const isGeocodeable =
        location.zip.length > 0 ||
        (location.city.length > 0 && location.state.length > 0);

    return isGeocodeable ? location : null;
};
